//core
import React from 'react';
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

//theme
import { Theme } from "@mui/material/styles/createTheme";
import { useTheme } from "@mui/styles";

interface IBetOutcomeProps {
  value: any;
}

const BetOutcome: React.FC<IBetOutcomeProps> = ({ value }): React.ReactElement => {
  const theme: Theme = useTheme();
  const { t } = useTranslation();

  const {
    // eventName,
    // eventStartTime,
    // sportName,
    marketName,
    outcomeName,
  } = value.items[0];

  return (
    <>
      {value.items.length === 1 ? (
        <>
          <Typography variant="body2">{outcomeName}</Typography>
          <Typography variant="body2" color="text.disabled" style={{ whiteSpace: 'nowrap' }}>
            {marketName}
          </Typography>
        </>
      ) : ''}
    </>
  );
};

export default BetOutcome;
